module.exports = __webpack_public_path__ + "static/media/IconTemplates_-84.ac16d4e4.svg";